/* eslint-disable no-extend-native */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
import React, { useContext, useState } from "react";
import { UserContext } from "../context/userContext";
import { useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Row, Col } from 'react-bootstrap'
import Box from '@mui/material/Box';
import { connect } from "react-redux";
import { useCookies } from "react-cookie";
import "./signinmodel.css"

function SignInModal(props) {
    const { modalState, toggleModals, signIn, getAccessForUser } = useContext(UserContext);

    const navigate = useNavigate();

    const [validation, setValidation] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("")
    const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");

    const handleForm = async (e) => {
        e.preventDefault();
        try {
            var signedInUser = await signIn(
                email,
                password
            );
            var user = await getAccessForUser(signedInUser.user);
            props.setUserRole(user.role)
            setCookie("whatson", user)
            setValidation("");
            toggleModals("close");
            navigate("/");
        } catch(e) {
            console.log(e)
            setValidation("Oops, email and/or password incorrect")
        }
    };

    const closeModal = () => {
        setValidation("");
        toggleModals("close");
    };

    return (
        <>
            {modalState.signInModal && (
                <div className="position-fixed top-0 vw-100 vh-100" style={{zIndex:2000}}>
                    <div
                        onClick={closeModal}
                        className="w-100 h-100 bg-dark bg-opacity-90"
                    ></div>
                    <div
                        className="position-absolute top-50 start-50 translate-middle modelcontainer"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <Col>
                                        <h5 className="modal-title" style={{ color: "white" }}>Sign In</h5>
                                    </Col>
                                    <div data-bs-theme="dark">
                                        <button type="button" class="btn-close" aria-label="Close" onClick={()=> toggleModals("close")}></button>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div component="form" onSubmit={handleForm}>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col>
                                                <TextField id="email" variant="filled" label="Email"
                                                    sx={{
                                                        width: "100%",
                                                        input: {
                                                            background: "white"
                                                        }
                                                    }}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col>
                                                <TextField id="password" variant="filled" type="password" label="Password"
                                                    sx={{
                                                        width: "100%",
                                                        input: {
                                                            fontSize: 20,
                                                            background: "white"
                                                        }
                                                    }}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                        <p className="text-danger mt-1">{validation}</p>
                                        <Button type="submit" fullWidth variant="contained" color="primary" onClick={(e) => handleForm(e)}>Submit</Button>
                                        <Button style={{marginTop:10}} type="submit" fullWidth variant="contained" color="primary" onClick={() => {
                                            toggleModals("close");
                                            navigate("/forgotpassword")}
                                            }>Forgot Password</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInModal);

function mapStateToProps(state) {
  return {
      userRole: state.userRole
  }
}

function mapDispatchToProps(dispatch) {
  return {
      setUserRole: (e) => dispatch({
          type: 'SET_USERROLE',
          text: e
      })
  }
}